<script>

import NewArticle from "@/views/components/cms/new/NewArticle.vue";

export default {
  name: "WohngeldKZuschlagNew",
  components: {
    NewArticle,
  },
}
</script>

<template>
  <NewArticle :category-id=14></NewArticle>
</template>

<style scoped>

</style>
